import { Navigate, createBrowserRouter } from 'react-router'
import { AppShell } from '../shell/AppShell.tsx'
import { RedirecionaItem } from './RedirecionaItem.tsx'
import { AppsRuntimeProvider } from '../features/app/runtime.tsx'
import { RequireAuth } from '../lib/session.tsx'
import { AdminPage } from '../pages/AdminPage.tsx'
import { ConsolePage } from '../pages/ConsolePage.tsx'
import { AccountSettingsPage } from '../pages/AccountSettingsPage.tsx'
import { AnalyticsPage } from '../pages/AnalyticsPage.tsx'
import { AppsPage } from '../features/app/AppsPage.tsx'
import { AutomationsPage } from '../pages/AutomationsPage.tsx'
import { BroadcastPage } from '../pages/BroadcastPage.tsx'
import { CalendarPage } from '../pages/CalendarPage.tsx'
import { ChannelsPage } from '../pages/ChannelsPage.tsx'
import { CompaniesPage } from '../pages/CompaniesPage.tsx'
import { PeoplePage } from '../pages/PeoplePage.tsx'
import { DocsPage } from '../pages/DocsPage.tsx'
import { DownloadPage } from '../pages/DownloadPage.tsx'
import { IrPage } from '../pages/IrPage.tsx'
import { EntrarNaChamadaPage } from '../pages/EntrarNaChamadaPage.tsx'
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage.tsx'
import { ResetPasswordPage } from '../pages/ResetPasswordPage.tsx'
import { RequestInvitePage } from '../pages/RequestInvitePage.tsx'
import { AceitarConvitePage } from '../pages/AceitarConvitePage.tsx'
import { ConfirmEmailPage } from '../pages/ConfirmEmailPage.tsx'
import { SetupWorkspacePage } from '../pages/SetupWorkspacePage.tsx'
import { ProfilePage } from '../pages/ProfilePage.tsx'
import { ConectarAoClaudePage } from '../pages/ConectarAoClaudePage.tsx'
import { ConsentimentoDoClaudePage } from '../pages/ConsentimentoDoClaudePage.tsx'
import { GroupsPage } from '../pages/GroupsPage.tsx'
import { HomePage } from '../pages/HomePage.tsx'
import { KanbansPage } from '../pages/KanbansPage.tsx'
import { LoginPage } from '../pages/LoginPage.tsx'
import { MailPage } from '../pages/MailPage.tsx'
import { MeetingsPage } from '../pages/MeetingsPage.tsx'
import { OfficePage } from '../pages/OfficePage.tsx'
import { ReuniaoDoEscritorioPage } from '../pages/SalaDoEscritorioPage.tsx'
import { NotificationsPage } from '../pages/NotificationsPage.tsx'
import { PlaceholderPage } from '../pages/PlaceholderPage.tsx'
import { PortfolioTreePage } from '../pages/PortfolioTreePage.tsx'
import { PortfolioNodePage } from '../pages/PortfolioNodePage.tsx'
import { StatusPage } from '../pages/StatusPage.tsx'
import { PluginScreenPage } from '../pages/PluginScreenPage.tsx'
import { PortalDoDesenvolvedorPage } from '../pages/PortalDoDesenvolvedorPage.tsx'
import { WorkItemsPage } from '../features/work-item/WorkItemsPage.tsx'
import { NovoWorkspacePage } from '../features/workspace/NovoWorkspacePage.tsx'
import { WorkspaceSettingsPage } from '../features/workspace/WorkspaceSettingsPage.tsx'

/**
 * Mapa de rotas da spec 9.
 *
 * Toda rota do documento existe aqui — as que ainda nao tem tela renderizam
 * `PlaceholderPage`, que explica o que a tela fara e cita o id da spec. Assim a
 * navegacao nunca leva a um 404 e o que falta fica visivel.
 */
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  // Solicitacao publica de convite (2026-08-26): o lancamento e por convite, o
  // cadastro publico direto foi desativado — /signup redireciona para ca.
  { path: '/request-invite', element: <RequestInvitePage /> },
  { path: '/signup', element: <Navigate to="/request-invite" replace /> },
  { path: '/confirm-email', element: <ConfirmEmailPage /> },
  // Aceite do convite liberado no Console (SPEC-20261001-1035): publica, fora do shell
  { path: '/invite', element: <AceitarConvitePage /> },
  // Conta sem nenhum workspace cai aqui (SPEC-20260814-2128)
  { path: '/setup-workspace', element: <SetupWorkspacePage /> },
  // Fora do shell autenticado: quem esqueceu a senha, por definicao, nao esta logado.
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  // Fora do shell autenticado: quem baixa o aplicativo pode nem ter conta.
  { path: '/download', element: <DownloadPage /> },
  // link que abre no Desktop ou segue para a web (SPEC-20261104-1214)
  { path: '/ir', element: <IrPage /> },
  // Fora do shell autenticado: quem entra por link de chamada NAO tem conta
  // (SPEC-20260917-0047). O token do link e a unica credencial.
  { path: '/entrar/:token', element: <EntrarNaChamadaPage /> },
  // a aba própria da reunião (SPEC-20261010-0332) saiu: a reunião agora abre dentro do Orbind
  { path: '/office/sala/:id', element: <Navigate to="/office" replace /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppsRuntimeProvider>
          <AppShell />
        </AppsRuntimeProvider>
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/home" replace /> },
      { path: 'home', element: <HomePage /> },
      // Edicao do workspace ativo — aberta pelo nome no topo do explorer
      { path: 'workspace', element: <WorkspaceSettingsPage /> },
      // Criar workspace adicional (FormScreen; o 1o workspace e /setup-workspace)
      { path: 'workspace/new', element: <NovoWorkspacePage /> },
      // Perfil do usuario — aberto pelo menu do avatar (SPEC-20260814-2128)
      { path: 'profile', element: <ProfilePage /> },
      // Conector do Claude (SPEC-20261103-1818) — menu do usuario
      { path: 'claude', element: <ConectarAoClaudePage /> },
      // consentimento OAuth do conector (SPEC-20261103-1822): a URL so traz o id
      { path: 'claude/autorizar/:id', element: <ConsentimentoDoClaudePage /> },
      // Configuracoes da CONTA (tipo, dados de empresa, plano) — menu do usuario
      { path: 'account', element: <AccountSettingsPage /> },
      // "Meus Estilos" da Comunicacao (SPEC-20260917-0010) — menu do usuario

      // Portfolio — PORT-01..05
      { path: 'portfolio', element: <Navigate to="/portfolio/tree" replace /> },
      { path: 'portfolio/tree', element: <PortfolioTreePage /> },
      // criar virou o formulario aberto pelo "+" do explorer e pelo "Adicionar
      // filho" do cabecalho — a rota so leva de volta a arvore
      { path: 'portfolio/new', element: <Navigate to="/portfolio/tree" replace /> },
      { path: 'portfolio/:id', element: <PortfolioNodePage /> },
      { path: 'portfolio/:id/roadmap', element: <PlaceholderPage title="Roadmap" specId="PORT-05" /> },

      // o wizard de 4 passos e a triagem vivem na caixa de entrada (modal
      // aberto pelo "+" do explorer), entao a rota antiga so redireciona

      // Itens de Trabalho — WI-01..05 (explorer split view do prototipo v2)
      // Tela de plugin: sempre sob /plugins/, para nao colidir com modulo nativo
      { path: 'plugins/:key/:ext', element: <PluginScreenPage /> },
      // Portal de quem ESCREVE plugin — nada a ver com instalar (isso e no admin)
      { path: 'developer', element: <PortalDoDesenvolvedorPage /> },
      /*
       * A LISTA de Itens de Trabalho mudou de lugar (SPEC-20261003-1059): mora
       * dentro de Trabalho, no nó do explorer. Quem tem o link antigo salvo
       * chega lá, em vez de cair numa tela que o rail não leva mais a lugar
       * nenhum.
       *
       * A tela de EDIÇÃO (`work-items/:id`) fica onde está: é destino de link
       * em notificação, chat e e-mail.
       */
      { path: 'work-items', element: <Navigate to="/kanbans/items" replace /> },
      { path: 'work-items/tree', element: <Navigate to="/kanbans/items" replace /> },
      { path: 'work-items/new', element: <WorkItemsPage /> },
      { path: 'work-items/my', element: <Navigate to="/kanbans/items" replace /> },
      /*
       * A edição do item também mudou de lugar
       * (SPEC-20261006-1351-item-abre-ao-lado-do-explorer): abre ao lado do
       * explorer de Trabalho. Notificação, chat e e-mail apontam para
       * `/work-items/:id` — o redirecionamento mantém esses links valendo, com
       * a query (o `?novo=1` da criação) junto.
       */
      { path: 'work-items/:id', element: <RedirecionaItem /> },

      // Kanban — explorer + quadro com config in-board (prototipo v2)
      { path: 'kanbans', element: <KanbansPage /> },
      // o nó "Itens de Trabalho" do explorer — segmento fixo, que o roteador
      // prefere a `kanbans/:id`
      { path: 'kanbans/items', element: <KanbansPage /> },
      // um item aberto pela lista de Itens, ao lado do explorer
      { path: 'kanbans/items/:workItemId', element: <KanbansPage /> },
      { path: 'kanbans/:id', element: <KanbansPage /> },
      // detalhe do item aberto pelo quadro: o explorer continua sendo o de
      // Quadros e o "voltar" retorna ao quadro com o cartao selecionado
      { path: 'kanbans/:id/items/:workItemId', element: <KanbansPage /> },
      { path: 'admin/kanbans', element: <Navigate to="/kanbans" replace /> },
      { path: 'admin/kanbans/new', element: <Navigate to="/kanbans" replace /> },
      { path: 'admin/kanbans/:id/configure', element: <Navigate to="/kanbans" replace /> },

      // Empresas: modulo proprio do rail (ex-tela da Administracao); o
      // endereco antigo redireciona
      { path: 'companies', element: <CompaniesPage /> },
      { path: 'people', element: <PeoplePage /> },
      { path: 'admin/companies', element: <Navigate to="/companies" replace /> },

      // Aplicacoes — SPEC-20260812-2351: atalhos do usuario abertos dentro do
      // Orbind. Os iframes vivem no shell, entao trocar de /apps para /apps/:id
      // nao recarrega nada — so muda qual esta visivel.
      { path: 'apps', element: <AppsPage /> },
      { path: 'apps/:id', element: <AppsPage /> },

      // Comunicacao — COM-01..03 (explorer de canais + conversa, dados mocados)
      { path: 'channels', element: <ChannelsPage /> },
      { path: 'channels/:id', element: <ChannelsPage /> },
      // Grupos: mesma anatomia da Comunicacao, criacao em 2 passos (mocado)
      { path: 'groups', element: <GroupsPage /> },
      { path: 'groups/:id', element: <GroupsPage /> },
      // Canais de avisos: somente leitura, so administradores publicam (mocado)
      { path: 'broadcast', element: <BroadcastPage /> },
      { path: 'broadcast/:id', element: <BroadcastPage /> },
      // Central de notificacoes agrupada (hoje / esta semana / antes), mocada
      { path: 'notifications', element: <NotificationsPage /> },

      // Modulos novos do protótipo v2
      // Reunioes: agenda + dock da reuniao, ainda com dados mocados
      { path: 'meetings', element: <MeetingsPage /> },
      { path: 'office', element: <OfficePage /> },
      { path: 'office/reuniao', element: <ReuniaoDoEscritorioPage /> },
      // Documentos e E-mail: explorer + conteudo, ainda com dados mocados
      { path: 'docs', element: <DocsPage /> },
      { path: 'docs/:id', element: <DocsPage /> },
      // Calendario: grade do mes + agenda do dia, ainda com dados mocados
      { path: 'calendar', element: <CalendarPage /> },
      { path: 'mail', element: <MailPage /> },
      { path: 'mail/:id', element: <MailPage /> },

      // Automacoes — AUT-01..03 (split view explorer + regra; dados mocados)
      { path: 'automations', element: <AutomationsPage /> },
      { path: 'automations/new', element: <AutomationsPage /> },
      { path: 'automations/:id', element: <AutomationsPage /> },
      { path: 'automations/:id/runs', element: <AutomationsPage /> },

      // Metricas — MET-01..04 (painel com graficos SVG; dados mocados)
      { path: 'analytics', element: <Navigate to="/analytics/flow" replace /> },
      { path: 'analytics/flow', element: <AnalyticsPage /> },
      { path: 'analytics/portfolio', element: <AnalyticsPage /> },

      // Status pessoal — publicar o meu status e ver o status da equipe
      // (dados mocados; regioes showStatus/listStatus/statusViewing do v2)
      { path: 'status', element: <StatusPage /> },

      // Administracao — ADM-01..11 (explorer de cadastros + tabela, mocado)
      // `:section` cobre todos os cadastros; slug desconhecido cai no cartao
      // "cadastro ainda nao disponivel" da propria AdminPage.
      { path: 'admin', element: <AdminPage /> },
      { path: 'admin/users', element: <Navigate to="/admin/members" replace /> },
      { path: 'admin/:section', element: <AdminPage /> },

      // Console do super admin (fora do plano/permissao; guard no servidor)
      { path: 'console', element: <ConsolePage /> },
      { path: 'console/:section', element: <ConsolePage /> },

      { path: '*', element: <PlaceholderPage title="Rota não encontrada" /> },
    ],
  },
])
